// Auto-generated by backend/generate_quick_search_ui.py — quick search + back-to-top labels (11 languages).
export const SEARCH_UI = {
  "search": {
    "id": "Cari",
    "en": "Search",
    "ar": "بحث",
    "fr": "Rechercher",
    "de": "Suchen",
    "es": "Buscar",
    "ru": "Поиск",
    "zh": "搜索",
    "ja": "検索",
    "ko": "검색",
    "hi": "खोजें"
  },
  "title": {
    "id": "Pencarian Cepat",
    "en": "Quick Search",
    "ar": "البحث السريع",
    "fr": "Recherche Rapide",
    "de": "Schnellsuche",
    "es": "Búsqueda Rápida",
    "ru": "Быстрый поиск",
    "zh": "快速搜索",
    "ja": "クイック検索",
    "ko": "빠른 검색",
    "hi": "त्वरित खोज"
  },
  "placeholder": {
    "id": "Cari doa, manasik, halaman, tanya jawab…",
    "en": "Search duas, manasik, pages, Q&A…",
    "ar": "ابحث عن الأدعية، المناسك، الصفحات، الأسئلة والأجوبة…",
    "fr": "Rechercher des invocations, manasik, pages, Q&R…",
    "de": "Duas, Manasik, Seiten, Fragen & Antworten suchen…",
    "es": "Buscar duas, manasik, páginas, preguntas y respuestas…",
    "ru": "Поиск дуа, манасик, страниц, вопросов и ответов…",
    "zh": "搜索祈祷词、朝觐礼仪、页面、问答…",
    "ja": "ドゥア、マナシク、ページ、Q&Aを検索…",
    "ko": "두아, 마나시크, 페이지, 질문과 답변 검색…",
    "hi": "दुआ, मनासिक, पृष्ठ, प्रश्न और उत्तर खोजें…"
  },
  "hint": {
    "id": "Ketik minimal 2 huruf untuk mencari.",
    "en": "Type at least 2 characters to search.",
    "ar": "اكتب حرفين على الأقل للبحث.",
    "fr": "Saisissez au moins 2 caractères pour rechercher.",
    "de": "Geben Sie mindestens 2 Zeichen ein, um zu suchen.",
    "es": "Escriba al menos 2 caracteres para buscar.",
    "ru": "Введите не менее 2 символов для поиска.",
    "zh": "请输入至少2个字符以进行搜索。",
    "ja": "検索するには少なくとも2文字入力してください。",
    "ko": "검색하려면 최소 2자를 입력하세요.",
    "hi": "खोजने के लिए कम से कम 2 अक्षर टाइप करें।"
  },
  "pages": {
    "id": "Halaman",
    "en": "Pages",
    "ar": "الصفحات",
    "fr": "Pages",
    "de": "Seiten",
    "es": "Páginas",
    "ru": "Страницы",
    "zh": "页面",
    "ja": "ページ",
    "ko": "페이지",
    "hi": "पृष्ठ"
  },
  "manasik": {
    "id": "Manasik",
    "en": "Manasik",
    "ar": "المناسك",
    "fr": "Manasik",
    "de": "Manasik",
    "es": "Manasik",
    "ru": "Манасик",
    "zh": "朝觐礼仪",
    "ja": "マナシク",
    "ko": "마나시크",
    "hi": "मनासिक"
  },
  "duas": {
    "id": "Doa",
    "en": "Supplications",
    "ar": "الأدعية",
    "fr": "Invocations",
    "de": "Bittgebete",
    "es": "Súplicas",
    "ru": "Дуа (молитвы-просьбы)",
    "zh": "祈祷文",
    "ja": "ドゥアー（祈願）",
    "ko": "두아(간구 기도)",
    "hi": "दुआएँ"
  },
  "faq": {
    "id": "Tanya Jawab",
    "en": "FAQ",
    "ar": "الأسئلة الشائعة",
    "fr": "Foire aux questions",
    "de": "Häufig gestellte Fragen",
    "es": "Preguntas frecuentes",
    "ru": "Часто задаваемые вопросы",
    "zh": "常见问题解答",
    "ja": "よくある質問",
    "ko": "자주 묻는 질문",
    "hi": "सामान्य प्रश्न"
  },
  "noResults": {
    "id": "Tidak ada hasil untuk “{q}”.",
    "en": "No results for \"{q}\".",
    "ar": "لا توجد نتائج لـ \"{q}\".",
    "fr": "Aucun résultat pour \"{q}\".",
    "de": "Keine Ergebnisse für \"{q}\".",
    "es": "No hay resultados para \"{q}\".",
    "ru": "Нет результатов для \"{q}\".",
    "zh": "没有找到与\"{q}\"相关的结果。",
    "ja": "「{q}」に一致する結果はありません。",
    "ko": "\"{q}\"에 대한 결과가 없습니다.",
    "hi": "\"{q}\" के लिए कोई परिणाम नहीं मिला।"
  },
  "askInstead": {
    "id": "Tanya Manasik: “{q}”",
    "en": "Ask Manasik: \"{q}\"",
    "ar": "اسأل المناسك: \"{q}\"",
    "fr": "Demander aux Manasik : \"{q}\"",
    "de": "Manasik fragen: \"{q}\"",
    "es": "Preguntar a Manasik: \"{q}\"",
    "ru": "Спросить Манасик: \"{q}\"",
    "zh": "询问朝觐礼仪：\"{q}\"",
    "ja": "マナーシクに質問する：「{q}」",
    "ko": "마나식에게 질문하기: \"{q}\"",
    "hi": "मनासिक से पूछें: \"{q}\""
  },
  "backToTop": {
    "id": "Kembali ke atas",
    "en": "Back to top",
    "ar": "العودة إلى الأعلى",
    "fr": "Retour en haut",
    "de": "Zurück nach oben",
    "es": "Volver arriba",
    "ru": "Вернуться наверх",
    "zh": "返回顶部",
    "ja": "トップへ戻る",
    "ko": "맨 위로 돌아가기",
    "hi": "ऊपर वापस जाएं"
  }
};
